import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { useDeviceType } from "../../../utils/hooks";
import AutoDownloader from "./AutoDownloader";
import ViewerDownloader from "./ViewerDownloader";

const DownloadMedicalDocuments = () => {
  const [searchParams] = useSearchParams();
  const urlsString = searchParams.get("urls");
  const urls = _.split(urlsString, "____");
  const deviceType = useDeviceType();
  const isIOS = deviceType === "ios";

  if (_.isEmpty(urls)) return null;

  if (isIOS) {
    return <ViewerDownloader urls={urls} />;
  }

  return <AutoDownloader urls={urls} />;
};

export default DownloadMedicalDocuments;
